// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__0MsJC","rounded":"Tag_rounded__V8htv"};